//stub component so that pattern can be established
import React, { KeyboardEvent, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { Alert, Button, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GridPaginationModel } from '@mui/x-data-grid';

import EmployeesGrid from '~/components/LeBusinessTraveller/components/EmployeesGrid';

import { getEmployeeList, getEmployeeSearch } from '~/services/BusinessTraveller/BusinessTravellerService';

interface Params {
  businessId: string;
  tab: string;
}

export default function EmployeesTab() {
  const [employees, setEmployees] = useState<Array<App.BusinessEmployee>>();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    pageSize: 10,
    page: 0,
  });
  const [totalEmployeeCount, setTotalEmployeeCount] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [fetchEmployeesError, setFetchEmployeesError] = useState(false);
  const [nameString, setNameString] = useState('');
  const { businessId } = useParams<keyof Params & string>();

  async function fetchEmployees() {
    try {
      const result = await getEmployeeList(businessId, paginationModel);
      setEmployees(result.result);
      setTotalEmployeeCount(result.meta.total);
      setFetchEmployeesError(false);
    } catch (e) {
      setFetchEmployeesError(true);
      console.error(e);
    }
  }

  useEffect(() => {
    fetchEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel]);

  async function clearFilters() {
    await fetchEmployees();
    setNameString('');
  }

  async function filter() {
    try {
      setIsFetching(true);
      const result = await getEmployeeSearch(businessId, nameString, paginationModel);
      setEmployees(result.result);
      setTotalEmployeeCount(result.meta.total);
      setFetchEmployeesError(false);
      setIsFetching(false);
    } catch (e) {
      setIsFetching(false);
      setFetchEmployeesError(true);
      console.error(e);
    }
    return;
  }

  async function handleEnterPress(e: KeyboardEvent<HTMLDivElement>) {
    if (e.key === 'Enter') {
      await filter();
    }
  }

  return (
    <Stack gap={2}>
      {fetchEmployeesError && <Alert severity="error">Error fetching employees</Alert>}
      <Typography variant="h5">Search for an Employee</Typography>
      <Stack>
        <Grid container spacing={2}>
          <Stack width="100%">
            <Grid size={12}>
              <TextField
                id="BusinessSearch"
                fullWidth
                label="Employee search"
                onChange={(e) => setNameString(e.target.value)}
                onKeyDown={handleEnterPress}
                placeholder="Enter Employee Name"
                type="text"
                value={nameString}
                variant="outlined"
              />
            </Grid>

            <Stack direction="row" gap={2} justifyContent="end">
              <Button onClick={clearFilters} variant="text">
                Clear all filters
              </Button>
              <Button onClick={filter} loading={isFetching} variant="contained">
                FILTER
              </Button>
            </Stack>
          </Stack>
          <EmployeesGrid
            onPaginationModelChange={setPaginationModel}
            paginationModel={paginationModel}
            rows={employees}
            total={totalEmployeeCount}
          />
        </Grid>
      </Stack>
    </Stack>
  );
}
